import React, { useState, useCallback, useEffect } from 'react';
import { MdMenu, MdFilterList, MdOutlineMenuOpen, MdKeyboardArrowRight } from "react-icons/md";
import { BsSliders, BsSliders2, BsList } from "react-icons/bs";


import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../../redux/store';
import { changeSidebarFilterType, changeSidebarType } from '../../redux/actions';
//import { SideBarFilterTypes, SideBarTypes } from '../../constants';
import { LayoutTypes, SideBarFilterTypes, SideBarTypes } from '../../constants/layout';
import FeatherIcon from 'feather-icons-react';
import { useLocation } from 'react-router-dom';
import { Button } from 'antd';

const LeftSidebarLever = ({ openLeftMenuCallBack, isMenuOpened }: any) => {
    const dispatch = useDispatch<AppDispatch>();
    const location = useLocation();

    const { layoutType, leftSideBarType, leftSideBarFilterType } = useSelector((state: RootState) => ({
        layoutType: state.Layout.layoutType,
        leftSideBarType: state.Layout.leftSideBarType,
        leftSideBarFilterType: state.Layout.leftSideBarFilterType,

    }));

    const handleLeftMenuCallBack = () => {
        //setIsopen(!isopen);
        if (openLeftMenuCallBack) openLeftMenuCallBack();
    };
    const ddFilter=()=>{
        handleLeftMenuCallBack()        
        toggleLeftSidebarFilterWidth()
    }

    const dd=()=>{
        handleLeftMenuCallBack()       
        toggleLeftSidebarWidth()
    }

    const ddClose=()=>{
        handleLeftMenuCallBack()       
        toggleLeftSidebarCloseWidth()
    }

    


    const toggleLeftSidebarCloseWidth = () => {        
        // if (leftSideBarFilterType === 'condensed')
        dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_CONDENSED));


        // if (leftSideBarFilterType === 'condensed')
        dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_CONDENSED));
        // else
        // dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_CONDENSED));

        // if (leftSideBarType === 'condensed') {
        //     dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT));
        // }

        // if (leftSideBarFilterType === 'condensed')
        //     dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_DEFAULT));

        //if (leftSideBarFilterType === 'default') dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_CONDENSED));

    };

    const toggleLeftSidebarWidth = () => {      
        dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT));

        // if (leftSideBarType === 'default' || leftSideBarType === 'compact')
        //     // if (leftSideBarFilterType === 'condensed')
        //         dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_CONDENSED));
        // // else
        // // dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_CONDENSED));

        // if (leftSideBarType === 'condensed') {
        //     dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT));
        // }

        //if (leftSideBarFilterType === 'default') dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_CONDENSED));

    };

    const toggleLeftSidebarFilterWidth = () => {        
        dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_DEFAULT));
        dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT));

        // if (leftSideBarType === 'condensed') {
        //     dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT));
        // }
        // if (leftSideBarFilterType === 'default' || leftSideBarFilterType === 'compact') {
        //     dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_CONDENSED));
        //     //dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_CONDENSED));
        // }
        // if (leftSideBarFilterType === 'condensed'){
        //  dispatch(changeSidebarFilterType(SideBarFilterTypes.LEFT_SIDEBAR_FILTER_TYPE_DEFAULT));
        //  //dispatch(changeSidebarType(SideBarTypes.LEFT_SIDEBAR_TYPE_DEFAULT));
        // }
    };

    return (
        <>
            <div className='sidebar-menu-lever'>
                <div style={{ display: 'flex', flexDirection: 'column' }} className='sidebar-lever-open2'>



                    {leftSideBarType !== 'condensed' &&
                        <div style={{ margin: '5px 0' }} onClick={toggleLeftSidebarCloseWidth} className='sidebar-menu-lever-open hand-pointer d-none d-lg-block'>
                            <div  className="menuIconClose" style={{ fontSize: 22, height: 35 }} />
                        </div>
                    }

                    {
                        (document.body.classList.contains('sidebar-enable')) && <div style={{ margin: '5px 0' }} onClick={ddClose} className='sidebar-menu-lever-open hand-pointer d-lg-none d-bolck'>
                            {/* <MdKeyboardArrowRight className="sanjabMenuIcon" style={{ fontSize: 22, height: '100%' }} /> */}
                            <div  className="menuIconClose" style={{ fontSize: 22, height: 35 }} />

                        </div>
                    }


                    {leftSideBarType === 'condensed' &&
                        <>
                            <div style={{ margin: '5px 0' }} onClick={toggleLeftSidebarWidth} className=' hand-pointer d-none d-lg-block'>
                            <div className="menuIcon" style={{ fontSize: 22, height: 35 }} />
                            </div>

                            {
                                // location.pathname.indexOf('/dashboard/dashboardPage') !== -1 ?
                                //     <div title='نمایش فیلتر' style={{ top: 70, margin: '5px 0' }} onClick={toggleLeftSidebarFilterWidth} className=' hand-pointer d-none d-lg-block'>
                                //         {/* <MdOutlineMenuOpen style={{ fontSize: 22 }} /> */}
                                //         <BsSliders2 className="sanjabMenuIcon" style={{ fontSize: 18 }} />
                                //     </div>
                                //     :
                                //     <div title='نمایش فیلتر' style={{ top: 70, margin: '5px 0' }} className='d-none d-lg-block'>
                                //         {/* <MdOutlineMenuOpen style={{ fontSize: 22 }} /> */}
                                //         <BsSliders2 style={{ fontSize: 18, color: '#959799' }} />
                                //     </div>
                            }
                        </>
                    }


                    {(!document.body.classList.contains('sidebar-enable')) &&
                        <>
                            <div style={{ margin: '5px 0' }} onClick={dd} className=' hand-pointer d-lg-none d-bolck'>
                                {/* <BsList style={{ fontSize: 20 }} /> */}
                                {/* <BsList className="sanjabMenuIcon" style={{ fontSize: 20 }} /> */}
                                <div  className="menuIcon" style={{ fontSize: 22, height: 35 }} />

                            </div>

                            {
                            // location.pathname.indexOf('/dashboard/dashboardPage') !== -1 ?
                            //     < div title='نمایش فیلتر' style={{ top: 70, margin: '5px 0' }} onClick={ddFilter} className=' hand-pointer d-lg-none d-bolck'>
                            //         {/* <MdOutlineMenuOpen style={{ fontSize: 22 }} /> */}
                            //         <BsSliders2 className="sanjabMenuIcon" style={{ fontSize: 18 }} />


                            //     </div>
                            //     :
                            //     < div title='نمایش فیلتر' style={{ top: 70, margin: '5px 0' }} className='d-lg-none d-bolck'>
                            //         {/* <MdOutlineMenuOpen style={{ fontSize: 22 }} /> */}
                            //         <BsSliders2  style={{ fontSize: 18, color:'#959799' }} />


                            //     </div>
                            }


                        </>
                    }

                </div>

            </div >
        </>
    );
};

export default React.memo(LeftSidebarLever);


